var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3324C6D5-1833-4CC4-8F56-735FDDE041CC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.95867188,4.60341639 L5.11117788,7.49366554 L3.40745192,5.76435811 L9.08653846,1.77635684e-15 L14.765625,5.76435811 L13.061899,7.49366554 L10.2064543,4.59534628 L10.1519351,12.6815878 L7.98593149,12.6815878 L7.95867188,4.60341639 Z M15.9014423,11.5287162 L18.1730769,11.5287162 L18.1730769,17.5 L1.42108547e-14,17.5 L1.42108547e-14,11.5287162 L2.27163462,11.5287162 L2.27163462,14.9873311 L15.9014423,14.9873311 L15.9014423,11.5287162 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Profile-&-Settings-\\uD83D\\uDC81\\uD83C\\uDFFB\\u200D\\u2640\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile---Photos-(1)",
    transform: "translate(-117.000000, -357.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Upload",
    transform: "translate(114.000000, 353.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.333333, 4.166667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Gray/Gray-3",
    mask: "url(#mask-2)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.333333, -4.166667)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 25
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.aaabd9f97855ca73c0c9a627f3b4fcee.svg";
export { ForwardRef as ReactComponent };